<template>

  <div v-if="isCrm" class="config-section orc-config-section">

    <div class="orc-config-hero">

      <div class="orc-config-hero__left">

        <div class="orc-config-hero__icon">

          <svg class="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.75">

            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>

          </svg>

        </div>

        <div class="orc-config-hero__text">

          <div class="orc-config-hero__title-row">

            <h2>{{ t('orcamentos.config.sectionTitle') }}</h2>

            <span class="orc-config-badge">CRM</span>

          </div>

          <p>{{ t('orcamentos.config.sectionSub') }}</p>

        </div>

      </div>

      <div class="orc-config-hero__actions">

        <Transition name="orc-fade">

          <span v-if="savedOk" class="orc-config-saved">

            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/></svg>

            {{ t('orcamentos.config.saved') }}

          </span>

        </Transition>

        <p v-if="saveError" class="orc-config-error">{{ saveError }}</p>

        <button type="button" class="orc-config-save" :disabled="saving" @click="saveSettings">

          <svg v-if="!saving" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4"/></svg>

          <span v-else class="orc-config-save__spinner" />

          {{ saving ? t('orcamentos.config.saving') : t('orcamentos.config.save') }}

        </button>

      </div>

    </div>



    <div class="orc-config-body">

      <div class="orc-config-panels">

        <section class="orc-config-panel">

          <header class="orc-config-panel__head">

            <div class="orc-config-panel__icon orc-config-panel__icon--empresa">

              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/></svg>

            </div>

            <div>

              <h3>{{ t('orcamentos.config.empresaTitle') }}</h3>

              <p>{{ t('orcamentos.config.empresaSub') }}</p>

            </div>

          </header>

          <div class="orc-config-grid">

            <label class="orc-config-field">

              <span>{{ t('orcamentos.config.empresaNome') }}</span>

              <div class="orc-config-input">

                <svg class="orc-config-input__icon" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>

                <input v-model="form.empresaNome" type="text" :placeholder="t('orcamentos.config.empresaNomePh')" />

              </div>

            </label>

            <label class="orc-config-field">

              <span>{{ t('orcamentos.config.empresaTelefone') }}</span>

              <div class="orc-config-input">

                <svg class="orc-config-input__icon" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/></svg>

                <input v-model="form.empresaTelefone" type="text" :placeholder="t('orcamentos.config.empresaTelefonePh')" />

              </div>

            </label>

            <label class="orc-config-field orc-config-field--full">

              <span>{{ t('orcamentos.config.empresaEndereco') }}</span>

              <div class="orc-config-input">

                <svg class="orc-config-input__icon" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/></svg>

                <input v-model="form.empresaEndereco" type="text" :placeholder="t('orcamentos.config.empresaEnderecoPh')" />

              </div>

            </label>

            <label class="orc-config-field orc-config-field--full">

              <span>{{ t('orcamentos.config.empresaEmails') }}</span>

              <div class="orc-config-input orc-config-input--textarea">

                <svg class="orc-config-input__icon orc-config-input__icon--top" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>

                <textarea v-model="form.empresaEmails" rows="2" :placeholder="t('orcamentos.config.empresaEmailsPh')" />

              </div>

            </label>

          </div>

        </section>



        <section class="orc-config-panel">

          <header class="orc-config-panel__head">

            <div class="orc-config-panel__icon orc-config-panel__icon--contrato">

              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"/></svg>

            </div>

            <div>

              <h3>{{ t('orcamentos.config.contratoTitle') }}</h3>

              <p>{{ t('orcamentos.config.contratoSub') }}</p>

            </div>

          </header>

          <div class="orc-config-grid">

            <label class="orc-config-field">

              <span>{{ t('orcamentos.config.validadeDias') }}</span>

              <div class="orc-form-qty-wrap">
                <button
                  type="button"
                  class="orc-form-qty-step"
                  :disabled="(Number(form.validadeDiasPadrao) || 1) <= 1"
                  @click="bumpValidadeDiasPadrao(-1)"
                >
                  −
                </button>
                <input
                  v-model.number="form.validadeDiasPadrao"
                  type="number"
                  min="1"
                  max="365"
                  class="orc-form-qty-input"
                >
                <button
                  type="button"
                  class="orc-form-qty-step"
                  :disabled="(Number(form.validadeDiasPadrao) || 1) >= 365"
                  @click="bumpValidadeDiasPadrao(1)"
                >
                  +
                </button>
                <span class="orc-form-qty-suffix">{{ t('orcamentos.config.daysSuffix') }}</span>
              </div>

            </label>

            <label class="orc-config-field orc-config-field--full">

              <span>{{ t('orcamentos.config.informacoesPadrao') }}</span>

              <div class="orc-config-input orc-config-input--textarea">

                <textarea v-model="form.informacoesGeraisPadrao" rows="3" :placeholder="t('orcamentos.config.informacoesPadraoPh')" />

              </div>

            </label>

            <label class="orc-config-field orc-config-field--full">

              <span>{{ t('orcamentos.config.condicoesPadrao') }}</span>

              <div class="orc-config-input orc-config-input--textarea">

                <textarea v-model="form.condicoesPagamentoPadrao" rows="3" :placeholder="t('orcamentos.config.condicoesPadraoPh')" />

              </div>

            </label>

          </div>

        </section>

      </div>



      <aside class="orc-config-preview">

        <div class="orc-config-preview__label">{{ t('orcamentos.config.previewTitle') }}</div>

        <div class="orc-config-preview__doc">

          <div class="orc-config-preview__doc-head">

            <div class="orc-config-preview__doc-logo">

              {{ previewInitials }}

            </div>

            <div class="orc-config-preview__doc-company">

              <strong>{{ form.empresaNome || t('orcamentos.config.previewCompanyFallback') }}</strong>

              <span v-if="form.empresaEndereco">{{ form.empresaEndereco }}</span>

              <span v-if="form.empresaTelefone">{{ form.empresaTelefone }}</span>

              <span v-if="firstEmail">{{ firstEmail }}</span>

            </div>

          </div>

          <div class="orc-config-preview__doc-line" />

          <div class="orc-config-preview__doc-meta">

            <span>{{ t('orcamentos.config.previewQuoteLabel') }}</span>

            <span class="orc-config-preview__doc-num">ORC-2026-0001</span>

          </div>

          <div class="orc-config-preview__doc-validity">

            {{ t('orcamentos.config.previewValidity', { days: form.validadeDiasPadrao || 15 }) }}

          </div>

        </div>

        <p class="orc-config-preview__hint">{{ t('orcamentos.config.previewHint') }}</p>

      </aside>

    </div>

  </div>

</template>



<script setup>

import { ref, computed, watch, onMounted } from 'vue'

import { useI18n } from 'vue-i18n'

import api from '@/services/api'

import '@/assets/styles/workspace-orcamentos.css'



const props = defineProps({

  workspaceId: { type: [Number, String], required: true },

  workspaceTipo: { type: String, default: '' }

})



const { t } = useI18n()

const saving = ref(false)

const savedOk = ref(false)

const saveError = ref('')

let savedTimer = null



const form = ref({

  empresaNome: '',

  empresaEndereco: '',

  empresaTelefone: '',

  empresaEmails: '',

  validadeDiasPadrao: 15,

  condicoesPagamentoPadrao: '',

  informacoesGeraisPadrao: ''

})



const isCrm = computed(() => String(props.workspaceTipo || '').toUpperCase() === 'CRM')



const firstEmail = computed(() => {

  const line = String(form.value.empresaEmails || '').split(/\r?\n/).map(s => s.trim()).find(Boolean)

  return line || ''

})



const previewInitials = computed(() => {

  const name = String(form.value.empresaNome || '').trim()

  if (!name) return 'OR'

  const parts = name.split(/\s+/).filter(Boolean)

  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()

  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()

})



function bumpValidadeDiasPadrao (delta) {
  const current = Number(form.value.validadeDiasPadrao) || 15
  form.value.validadeDiasPadrao = Math.min(365, Math.max(1, current + delta))
}

async function load () {

  if (!props.workspaceId || !isCrm.value) return

  try {

    const { data } = await api.get(`/workspace-config/${props.workspaceId}/orcamento-settings`)

    form.value = {

      empresaNome: data?.empresaNome || '',

      empresaEndereco: data?.empresaEndereco || '',

      empresaTelefone: data?.empresaTelefone || '',

      empresaEmails: data?.empresaEmails || '',

      validadeDiasPadrao: data?.validadeDiasPadrao ?? 15,

      condicoesPagamentoPadrao: data?.condicoesPagamentoPadrao || '',

      informacoesGeraisPadrao: data?.informacoesGeraisPadrao || ''

    }

  } catch (e) {

    console.warn('Erro ao carregar config orçamentos:', e)

  }

}



function flashSaved () {

  savedOk.value = true

  clearTimeout(savedTimer)

  savedTimer = setTimeout(() => { savedOk.value = false }, 3200)

}



async function saveSettings () {

  if (!props.workspaceId) return

  saving.value = true

  saveError.value = ''

  try {

    await api.put(`/workspace-config/${props.workspaceId}/orcamento-settings`, form.value)

    flashSaved()

  } catch (e) {

    const msg = e?.response?.data?.error || e?.message || 'Erro ao salvar'

    saveError.value = msg

    console.error(e)

  } finally {

    saving.value = false

  }

}



watch(() => props.workspaceId, load)

onMounted(load)

</script>


